// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { WizardDraftScope } from "./wizard-draft-scope";
import { WizardDraftState } from "./wizard-draft-state";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * One saved wizard step for one scope of an organization (`wizard_drafts`).
 */
export class WizardDraft implements flatbuffers.IUnpackableObject<WizardDraftT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): WizardDraft {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsWizardDraft(bb: flatbuffers.ByteBuffer, obj?: WizardDraft): WizardDraft {
    return (obj || new WizardDraft()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsWizardDraft(
    bb: flatbuffers.ByteBuffer,
    obj?: WizardDraft,
  ): WizardDraft {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new WizardDraft()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * The organization the draft belongs to.
   */
  orgId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * What `scope_id` names: the organization, one of its servers, or a bank.
   */
  scopeType(): WizardDraftScope {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : WizardDraftScope.UNSET;
  }

  /**
   * The organization, server or bank the step is being filled in for.
   */
  scopeId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * The wizard step the draft was saved from.
   */
  stepIndex(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  /**
   * The version of the body's shape the server stamped.
   */
  schemaVersion(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 1;
  }

  status(): WizardDraftState {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : WizardDraftState.UNSET;
  }

  /**
   * The legacy body: the step's state as JSON text, carried verbatim. Absent
   * when the row holds only a typed body.
   */
  draftData(): string | null;
  draftData(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  draftData(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * The typed body: a packed `Api.WizardDraftBody`, byte for byte as stored.
   * Absent when the row holds only the legacy JSON.
   */
  draftBinary(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  draftBinaryLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  draftBinaryArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  updatedAt(): string | null;
  updatedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  updatedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  deletedAt(): string | null;
  deletedAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  deletedAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startWizardDraft(builder: flatbuffers.Builder) {
    builder.startObject(12);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addOrgId(builder: flatbuffers.Builder, orgIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, orgIdOffset, 0);
  }

  static addScopeType(builder: flatbuffers.Builder, scopeType: WizardDraftScope) {
    builder.addFieldInt8(2, scopeType, WizardDraftScope.UNSET);
  }

  static addScopeId(builder: flatbuffers.Builder, scopeIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, scopeIdOffset, 0);
  }

  static addStepIndex(builder: flatbuffers.Builder, stepIndex: number) {
    builder.addFieldInt32(4, stepIndex, 0);
  }

  static addSchemaVersion(builder: flatbuffers.Builder, schemaVersion: number) {
    builder.addFieldInt32(5, schemaVersion, 1);
  }

  static addStatus(builder: flatbuffers.Builder, status: WizardDraftState) {
    builder.addFieldInt8(6, status, WizardDraftState.UNSET);
  }

  static addDraftData(builder: flatbuffers.Builder, draftDataOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, draftDataOffset, 0);
  }

  static addDraftBinary(builder: flatbuffers.Builder, draftBinaryOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, draftBinaryOffset, 0);
  }

  static createDraftBinaryVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startDraftBinaryVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, createdAtOffset, 0);
  }

  static addUpdatedAt(builder: flatbuffers.Builder, updatedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, updatedAtOffset, 0);
  }

  static addDeletedAt(builder: flatbuffers.Builder, deletedAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, deletedAtOffset, 0);
  }

  static endWizardDraft(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // id
    builder.requiredField(offset, 6); // org_id
    builder.requiredField(offset, 10); // scope_id
    return offset;
  }

  unpack(): WizardDraftT {
    return new WizardDraftT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.orgId() !== null ? this.orgId()!.unpack() : null,
      this.scopeType(),
      this.scopeId() !== null ? this.scopeId()!.unpack() : null,
      this.stepIndex(),
      this.schemaVersion(),
      this.status(),
      this.draftData(),
      this.bb!.createScalarList<number>(this.draftBinary.bind(this), this.draftBinaryLength()),
      this.createdAt(),
      this.updatedAt(),
      this.deletedAt(),
    );
  }

  unpackTo(_o: WizardDraftT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.orgId = this.orgId() !== null ? this.orgId()!.unpack() : null;
    _o.scopeType = this.scopeType();
    _o.scopeId = this.scopeId() !== null ? this.scopeId()!.unpack() : null;
    _o.stepIndex = this.stepIndex();
    _o.schemaVersion = this.schemaVersion();
    _o.status = this.status();
    _o.draftData = this.draftData();
    _o.draftBinary = this.bb!.createScalarList<number>(
      this.draftBinary.bind(this),
      this.draftBinaryLength(),
    );
    _o.createdAt = this.createdAt();
    _o.updatedAt = this.updatedAt();
    _o.deletedAt = this.deletedAt();
  }

  unpackFields(...fields: string[]): WizardDraftT {
    const t = new WizardDraftT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("org_id")) {
      t.orgId = this.orgId() !== null ? this.orgId()!.unpack() : null;
    }
    if (fieldSet.has("scope_type")) {
      t.scopeType = this.scopeType();
    }
    if (fieldSet.has("scope_id")) {
      t.scopeId = this.scopeId() !== null ? this.scopeId()!.unpack() : null;
    }
    if (fieldSet.has("step_index")) {
      t.stepIndex = this.stepIndex();
    }
    if (fieldSet.has("schema_version")) {
      t.schemaVersion = this.schemaVersion();
    }
    if (fieldSet.has("status")) {
      t.status = this.status();
    }
    if (fieldSet.has("draft_data")) {
      t.draftData = this.draftData();
    }
    if (fieldSet.has("draft_binary")) {
      t.draftBinary = this.bb!.createScalarList<number>(
        this.draftBinary.bind(this),
        this.draftBinaryLength(),
      );
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("updated_at")) {
      t.updatedAt = this.updatedAt();
    }
    if (fieldSet.has("deleted_at")) {
      t.deletedAt = this.deletedAt();
    }
    return t;
  }
}

export class WizardDraftT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public orgId: UuidT | null = null,
    public scopeType: WizardDraftScope = WizardDraftScope.UNSET,
    public scopeId: UuidT | null = null,
    public stepIndex: number = 0,
    public schemaVersion: number = 1,
    public status: WizardDraftState = WizardDraftState.UNSET,
    public draftData: string | Uint8Array | null = null,
    public draftBinary: number[] = [],
    public createdAt: string | Uint8Array | null = null,
    public updatedAt: string | Uint8Array | null = null,
    public deletedAt: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.id === null || this.id === undefined) {
      throw new Error('Required field "id" is not set');
    }
    if (this.orgId === null || this.orgId === undefined) {
      throw new Error('Required field "org_id" is not set');
    }
    if (this.scopeId === null || this.scopeId === undefined) {
      throw new Error('Required field "scope_id" is not set');
    }
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const orgId = this.orgId !== null ? this.orgId!.pack(builder) : 0;
    const scopeId = this.scopeId !== null ? this.scopeId!.pack(builder) : 0;
    const draftData = this.draftData !== null ? builder.createString(this.draftData!) : 0;
    const draftBinary = WizardDraft.createDraftBinaryVector(builder, this.draftBinary);
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const updatedAt = this.updatedAt !== null ? builder.createString(this.updatedAt!) : 0;
    const deletedAt = this.deletedAt !== null ? builder.createString(this.deletedAt!) : 0;

    WizardDraft.startWizardDraft(builder);
    WizardDraft.addId(builder, id);
    WizardDraft.addOrgId(builder, orgId);
    WizardDraft.addScopeType(builder, this.scopeType);
    WizardDraft.addScopeId(builder, scopeId);
    WizardDraft.addStepIndex(builder, this.stepIndex);
    WizardDraft.addSchemaVersion(builder, this.schemaVersion);
    WizardDraft.addStatus(builder, this.status);
    WizardDraft.addDraftData(builder, draftData);
    WizardDraft.addDraftBinary(builder, draftBinary);
    WizardDraft.addCreatedAt(builder, createdAt);
    WizardDraft.addUpdatedAt(builder, updatedAt);
    WizardDraft.addDeletedAt(builder, deletedAt);

    return WizardDraft.endWizardDraft(builder);
  }

  clone(): WizardDraftT {
    const obj = new WizardDraftT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.orgId = this.orgId !== null ? this.orgId!.clone() : null;
    obj.scopeType = this.scopeType;
    obj.scopeId = this.scopeId !== null ? this.scopeId!.clone() : null;
    obj.stepIndex = this.stepIndex;
    obj.schemaVersion = this.schemaVersion;
    obj.status = this.status;
    obj.draftData = this.draftData;
    obj.draftBinary = [...this.draftBinary];
    obj.createdAt = this.createdAt;
    obj.updatedAt = this.updatedAt;
    obj.deletedAt = this.deletedAt;
    return obj;
  }

  equals(other: WizardDraftT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.orgId !== null && other.orgId !== null) {
      if (!this.orgId!.equals(other.orgId!)) return false;
    } else if (this.orgId !== other.orgId) return false;
    if (this.scopeType !== other.scopeType) return false;
    if (this.scopeId !== null && other.scopeId !== null) {
      if (!this.scopeId!.equals(other.scopeId!)) return false;
    } else if (this.scopeId !== other.scopeId) return false;
    if (this.stepIndex !== other.stepIndex) return false;
    if (this.schemaVersion !== other.schemaVersion) return false;
    if (this.status !== other.status) return false;
    if (this.draftData !== other.draftData) return false;
    if (this.draftBinary.length !== other.draftBinary.length) return false;
    for (let i = 0; i < this.draftBinary.length; i++) {
      if (this.draftBinary[i] !== other.draftBinary[i]) return false;
    }
    if (this.createdAt !== other.createdAt) return false;
    if (this.updatedAt !== other.updatedAt) return false;
    if (this.deletedAt !== other.deletedAt) return false;
    return true;
  }
}

export function verifyWizardDraft(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "id");
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "org_id");
    verifier.checkScalarField(tablePos, 8, 1);
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "scope_id");
    verifier.checkScalarField(tablePos, 12, 4);
    verifier.checkScalarField(tablePos, 14, 4);
    verifier.checkScalarField(tablePos, 16, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
